import { GxIcon } from "./icon.js"



export class GxIconMetric extends GxIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" 
  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
  aria-hidden="true">
  <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline>
</svg>
`
    super.addHTML(temp)
  }

}


if (!window.customElements.get("gx-icon-metric")) {
  window.customElements.define("gx-icon-metric", GxIconMetric)
}
